import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { gradientColor } from "../../contants";
export default function SubscribeModal({ open, close }) {
  return (
    <Dialog open={open} onClose={close} maxWidth="xs" fullWidth>
      <DialogTitle position="relative">
        <Box className="displayCenter" mt={1}>
          <img src="/assets/images/status.gif" />
        </Box>
        <Typography variant="h2" textAlign="center" mt={1}>
          <span style={gradientColor}>THANK YOU!!</span>
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: "3px", height: "120px" }}>
        <Typography variant="h6" textAlign="center" mt={1}>
          Stay tuned for the latest Insights, tips, & Crypto Market trends
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
